import { useMutation } from '@tanstack/react-query';
import { postDescartesDocumentSubmit, postThymeITDocumentSubmit } from '../../../api/v2/load';

export const useDocumentSubmit = () => {
  return {
    submitC21: useMutation({
      mutationFn: (data) => postDescartesDocumentSubmit({ data, type: 'C21' }),
    }),
    submitEAD: useMutation({
      mutationFn: (data) => postDescartesDocumentSubmit({ data, type: 'EAD' }),
    }),
    submitFFD: useMutation({
      mutationFn: (data) => postDescartesDocumentSubmit({ data, type: 'FFD' }),
    }),
    submitSDI: useMutation({
      mutationFn: (data) => postDescartesDocumentSubmit({ data, type: 'SDI' }),
    }),
    submitSFD: useMutation({
      mutationFn: (data) => postDescartesDocumentSubmit({ data, type: 'SFD' }),
    }),
    submitIEImport: useMutation({
      mutationFn: (data) => postThymeITDocumentSubmit({ data, type: 'IE_IMPORT' }),
    }),
    submitIEExport: useMutation({
      mutationFn: (data) => postThymeITDocumentSubmit({ data, type: 'IE_EXPORT' }),
    }),
  };
};
